/**
 * @jsx React.DOM
 */

import React from 'react';
import Option from './Option';
import ClassNames from 'classnames';
import Paper from 'components/paper/Paper';
import Transition from 'components/transition-groups/Transition'

export default React.createClass({



	propTypes: {
		options: React.PropTypes.array,
		customClasses: React.PropTypes.object,
		selectionIndex: React.PropTypes.number,
		onOptionSelected: React.PropTypes.func
	},

	getDefaultProps() {
		return {
			selectionIndex: null,
			customClasses: {},
			onOptionSelected: function(option) { }
		};
	},

	getInitialState() {
		return {
			selectionIndex: this.props.selectionIndex,
			selection: this.getSelectionForIndex(this.props.selectionIndex)
		};
	},

	render() {

		let classList = ClassNames(this.props.className, "lui-auto-selector", this.props.customClasses.results);
		let results = this.props.options.map(function(result, i) {
			return (
				<Option ref={result.label} key={result.label}
					hover={this.state.selectionIndex === i}
					customClasses={this.props.customClasses}
					onClick={this._onClick.bind(this, result)}>
					{ result.label }
				</Option>
			);
		}, this);

		return (

				<ul ref="container" key="selector-ul" className={classList}>{ results }</ul>

		);
	},

	setSelectionIndex(index) {
		this.setState({
			selectionIndex: index,
			selection: this.getSelectionForIndex(index),
		});
	},

	getSelectionForIndex(index) {
		if (index === null) {
			return null;
		}

		if (this.props.options.length) {
			return this.props.options[index];
		} else {
			return null;
		}
	},

	_onClick(result, event) {
		return this.props.onOptionSelected(result, event);
	},

	_nav(delta) {
		if (!this.props.options.length) {
			return;
		}
		
		let newIndex;
		
		if (this.state.selectionIndex === null) {
			if (delta == 1) {
				newIndex = 0;
			} else {
				newIndex = delta;
			}
		} else {
			newIndex = this.state.selectionIndex + delta;
		}


		if (newIndex < 0) {
			newIndex += this.props.options.length;
		} else if (newIndex >= this.props.options.length) {
			newIndex -= this.props.options.length;
		}
		
		let newSelection = this.getSelectionForIndex(newIndex);
		this.setState({selectionIndex: newIndex, selection: newSelection});
		
		let element = React.findDOMNode(this.refs[newSelection.label]);
		let container = React.findDOMNode(this.refs.container);

		// If there's no element, don't bother computing height and scroll
		if (element){


			let topPos = element.offsetTop;
			let elementHeight = window.getComputedStyle(element).height;
			let containerHeight = window.getComputedStyle(container).height;
			
			containerHeight = parseInt(containerHeight, 10);
			elementHeight = parseInt(elementHeight, 10);

			// If containerHeight derps out (which it has like a one in ten chance of doing) set it again.
			// This should pretty much prevent it from ever being 0.
			if (containerHeight === 0) {
				containerHeight = window.getComputedStyle(container).height;
			}

			container.scrollTop = topPos - containerHeight + elementHeight;
		}

	},

	navDown() {
		this._nav(1);
	},

	navUp() {
		this._nav(-1);
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/autocomplete/Selector.js
 **/